import { Card } from "@/components/ui/card";
import Image from "next/image";
import Link from "next/link";
import { BlogData } from "@/types/blogs";
import link from "@/lib/localEndPoints";
import {Default_image} from '@/lib/utils'
import fixNewsContent from "@/lib/SVG_Render";
export const NewsUpdateCard = ({ news }: { news: BlogData }) => {
  // Derive image URL and alt text once
  const imageUrl = news.media?.[0]?.url;
  const imageAlt = news.slug || news.title || "News Update Image";
  const placeholderImage = imageUrl || Default_image; 

  // Pre-calculate the href for the Link
  const newsHref = `${link.NEWS}/${news.slug}`;

  return (
    <Link
      href={newsHref}
      className="block h-full"
    >
      <Card className="overflow-hidden h-full rounded-2xl p-0 gap-0 shadow-sm hover:shadow-lg transition-all duration-300">
        <div className="relative aspect-3/2 overflow-hidden flex items-center justify-center group">
          {imageUrl && ( 
            <Image
              src={imageUrl}
              alt={imageAlt}
              blurDataURL={placeholderImage} 
              placeholder="blur"
              loading="lazy" 
              fill
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
              className="object-cover transition-transform duration-300 ease-in-out bg-white group-hover:scale-110" 
              quality={75} 
            />
          )}
          {!imageUrl && ( // Fallback div if no image URL is provided
             <div className="w-full h-full bg-gray-200 flex items-center justify-center text-gray-500">
                No Image
             </div>
          )}
        </div>
        <div className="flex-1 px-2 md:px-4 py-4 ">
          <p className="text-muted-foreground text-xs md:text-sm flex items-center gap-2 flex-wrap">
            {news.published_at}
            {news.is_pinned && (
              // Pinned badge
              <span className="ml-2 px-2 py-0.5 text-xs md:text-sm rounded-full bg-blue-100 text-blue-800 font-medium">
                Pinned
              </span>
            )}
          </p>
          <h2 className="text-base md:text-lg lg:text-xl font-semibold mt-3 line-clamp-2">
            {news.title}
          </h2>
          {news.content && (
            <div
              className="text-muted-foreground text-sm mt-4 leading-relaxed line-clamp-3"
              dangerouslySetInnerHTML={{ __html: fixNewsContent(news.content) }}
            />
          )}
        </div>
      </Card>
    </Link>
  );
};